import React from "react";

export default class EditTagProperty extends React.Component {
    constructor (props) {
        super(props);

        this.displayPlayerNames = true;
        // Property names where we should look on the opposing team
        this.invertedTeamProperties = ["offending player", "keeper"];
    }

    createCustomOptionArray (options) {
        return options.map((option) => ({
            id: option,
            text: option,
            value: option,
        }));
    }

    getPlayersToText () {
        let teamFilter = this.props.teamFilter;
        if (this.invertedTeamProperties.indexOf(this.props.name) >= 0 ||
            (this.props.isOwnGoal && this.props.name === "scorer")) {
            // Invert the list - look for opposing players
            teamFilter = this.props.lineup.getOppositeTeam(teamFilter);
        }
        return this.props.lineup.playersToText(teamFilter, this.displayPlayerNames);
    }

    render () {

        let options;//Array of elements with {id,value,text}
        switch (this.props.type) {
            case "team":
                options = this.props.lineup.teamsToText();
                break;
            case "player":
                options = this.getPlayersToText();
                break;
            default:
                options = this.createCustomOptionArray(this.props.customOptions);
        }

        let optionElements = options.map((option) => (
            <td key={option.id}>
                <a className={"list-group-item" + (option.value===this.props.value ? " active" : "")}
                    onClick={() => this.props.onChange(option.id, option.value)}>
                    {option.extraInfo && (
                        <span className="player-option-position-badge">{option.extraInfo}</span>
                    )}
                    <span style={{marginRight: "5px"}}>{option.text}</span>
                </a>
            </td>
        ));

        //Chunk options into rows
        const maxOptionsPerRow = this.displayPlayerNames ? 3 : 9;
        let optionRows = [];
        for (let i=0; i<optionElements.length; i+=maxOptionsPerRow) {
            optionRows.push(
                <tr key={i}>
                    {optionElements.slice(i, i+maxOptionsPerRow)}
                </tr>
            );
        }

        return (
            <table className="table table-options-container">
                <tbody>
                    {optionRows}
                </tbody>
            </table>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/EditTagProperty.js